import { render } from "./Main.vue?vue&type=template&id=40572d83&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=40572d83&lang=scss&scoped=true"
import "./Main.vue?vue&type=style&index=1&id=40572d83&lang=scss"

import exportComponent from "E:\\项目\\弗莱德\\DL-Flight.Protal\\DL-Flight.Protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40572d83"]])

export default __exports__